/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('site.foreign', [], function (el) {
        function handleForeignClick(e) {
            if (!el.classList.contains('open')) {
                e.preventDefault();
            }
            el.classList.toggle('open');
        }
        util.delegate(el, 'click', '.foreign', function (e) { return handleForeignClick(e); });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
